// components

import { Box, Container, Grid, Stack, Typography } from "@mui/material";
import { SvgIconStyle } from "components";

//ui data
import { HistoryList, Philosophy, Platform } from "utils/uiData";
import { AboutBtn, History, MiniLine, RowLineText } from "utils/unitComponent";

//images
import CornerIcon from "assets/icons/corner.svg";
import AboutImg from "assets/images/about-bg.png";
import IntroImg from "assets/images/intro.png";
import { useNavigate } from "react-router-dom";

// ----------------------------------------------------------------------

export default function About() {
  const navigate = useNavigate();
  return (
    <>
      <Box
        sx={{
          height: "100vh",
        }}
      >
        {/* bg-img */}
        <Box
          sx={{
            width: "100%",
            height: "70%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            background: `center/cover no-repeat url(${AboutImg})`,
            position: "relative",
          }}
        >
          {/* icon  */}
          <Container
            sx={{
              position: "absolute",
              top: 100,
              px: "0 !important",
              textAlign: "right",
            }}
          >
            <SvgIconStyle src={CornerIcon} size={45} origin />
          </Container>
          <Box
            sx={{
              mt: 10,
              color: "white",
              textAlign: "center",
            }}
          >
            <Typography variant="body" fontWeight={500}>
              "기다림 없이 원하는 시간에 원하는 상품을"
            </Typography>
            <Box
              sx={{
                borderColor: "white",
                borderWidth: "0px 8px 0px 8px",
                borderStyle: "solid",
                px: 4,
                mt: 2,
                height: 95,
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontWeight: "light",
                  lineHeight: 1.5,
                }}
              >
                <strong>페스티벌</strong>을 빛나게 할<br />
                <strong>완벽한 몰입의 경험</strong>을 설계합니다.
              </Typography>
            </Box>
          </Box>
          {/* text */}
        </Box>
        {/* 예약 플랫폼 Text */}
        <Stack
          justifyContent="center"
          sx={{
            textAlign: "center",
            height: "30%",
          }}
        >
          <Typography variant="h5" sx={{ mb: 3 }}>
            페스티벌 스마트 예약 플랫폼, 퀸즈
          </Typography>

          <Stack direction="row" justifyContent="center" spacing={25}>
            {Platform.map((item, i) => (
              <RowLineText key={i} item={item} />
            ))}
          </Stack>
        </Stack>
      </Box>

      {/* 성장 */}
      <Box
        sx={{
          height: "63vh",
          display: "flex",
          alignItems: "center",
          position: "relative",
          bgcolor: "grey.light",
        }}
      >
        {/* left */}
        <Container sx={{ px: "0 !important" }}>
          <Box>
            <Typography
              variant="body"
              sx={{
                fontWeight: "regular",
              }}
            >
              퀸즈는 문화 이벤트의 주최사와 관객, 모두에게
            </Typography>
            <Typography variant="h4" sx={{ mt: 1, mb: 2 }}>
              기다림 없는 즐거움을 선사하며
              <br /> 현장의 든든한 서포터로서 성장해왔습니다
            </Typography>
            <Typography
              variant="body"
              sx={{
                fontWeight: "regular",
                lineHeight: 1.5,
              }}
            >
              다년간의 경험으로 탄탄한 실력과 노하우를 쌓아온 퀸즈의 운영
              전문가들과 함께 한다면 <br /> 주최사는 제공하는 프로그램에 온전히
              집중할 수 있고, 관객은 편안함과 즐거움, 그 자체만을 경험합니다.
              <br />
            </Typography>
            <Box sx={{ my: 1.3 }}>
              <Typography
                variant="body"
                sx={{
                  fontWeight: "regular",
                  lineHeight: 1.5,
                }}
              >
                이벤트를 찾는 특별한 하루만큼은 나를 둘러싼 평범한 일상을 잊고
                오롯이 그 순간에 몰입할 수 있도록,
                <br /> 그 하루가 끝나면 다시 행복하게 일상으로 돌아갈 수 있도록,
                퀸즈는 필요한 모든 것을 지원합니다.
                <br />
              </Typography>
            </Box>

            <Typography
              variant="body"
              sx={{
                fontWeight: "regular",
                lineHeight: 1.5,
              }}
            >
              앞으로도 퀸즈는 더 많은 문화 이벤트를 빛나게 할&nbsp;
              <Box
                component="span"
                sx={{ color: "primary.main", fontWeight: "bold" }}
              >
                완벽한 몰입의 경험
              </Box>
              을 설계해 나가겠습니다.
            </Typography>
            <MiniLine sx={{ my: 4 }} />
            <Stack direction="row" spacing={10}>
              {Philosophy.map((item, i) => (
                <RowLineText key={i} item={item} small />
              ))}
            </Stack>
          </Box>
        </Container>
        {/* right img */}
        <Box
          sx={{
            position: "absolute",
            right: 0,
            height: "100%",
            width: "40%",
          }}
        >
          <Box
            component="img"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
            src={IntroImg}
          />
        </Box>
      </Box>
      {/* 퀸즈 */}
      <Box sx={{ height: "90vh" }}>
        {/* img */}
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            background: `top/cover no-repeat url(${AboutImg})`,
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.6)",
            },
          }}
        >
          {/* 필터 위 content */}
          <Box sx={{ zIndex: 1, textAlign: "center" }}>
            <Typography
              variant="title2"
              sx={{
                color: "primary.main",
              }}
            >
              2023년,
            </Typography>
            <br />
            <Typography
              variant="title2"
              sx={{
                color: "white",
              }}
            >
              <Box component="span" fontWeight="400">
                퀸즈스마일이
              </Box>
              &nbsp;퀸즈로 재도약합니다.
            </Typography>
            <MiniLine
              sx={{
                my: 4,
                mx: "auto",
              }}
            />
            {HistoryList.map((item, i) => (
              <Box
                key={i}
                sx={{
                  position: "relative",
                }}
              >
                <History
                  item={item}
                  isLeft={i % 2 === 1}
                  isLast={i === HistoryList.length - 1}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>

      {/* Press Release */}
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Container>
          <Typography variant="h4">Press Release</Typography>
          <MiniLine
            sx={{
              my: 4,
            }}
          />
          <Grid container spacing={2} sx={{ mb: 4 }}>
            {[...Array(4)].map((_, i) => (
              <Grid key={i} item xs={12} sm={6} md={3}>
                <Box
                  sx={{
                    width: "100%",
                    pb: "120%",
                    bgcolor: "grey.middle",
                    borderRadius: 1.5,
                  }}
                />
              </Grid>
            ))}
          </Grid>
          {/* button */}
          <AboutBtn
            onClick={(type) => {
              type === "service" ? navigate("/service") : console.log(type);
            }}
          />
        </Container>
      </Box>
    </>
  );
}

// ----------------------------------------------------------------------
